// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bjziysppvqpqpvewayzf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJqeml5c3BwdnFwcXB2ZXdheXpmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgyNzEwOTYsImV4cCI6MjA2Mzg0NzA5Nn0.5t_0HE0TDtsPZXzqAx6BWpKoG3mMHxTTN_oUARQLu2g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);